import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row items-center q-gutter-sm q-mb-md" }
const _hoisted_2 = { class: "row q-gutter-md" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "row items-center justify-between q-mb-sm" }
const _hoisted_5 = { class: "text-bold" }
const _hoisted_6 = { class: "row items-center q-gutter-xs" }
const _hoisted_7 = { class: "row items-center q-gutter-xs q-mb-sm" }
const _hoisted_8 = { class: "col-auto column justify-center q-gutter-sm" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "row items-center justify-between q-mb-sm" }
const _hoisted_11 = { class: "text-bold" }
const _hoisted_12 = { class: "row items-center q-gutter-xs q-mb-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_input, {
        modelValue: _ctx.searchFilter,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFilter) = $event)),
        dense: "",
        outlined: "",
        color: "blue-brand",
        label: "Search AGMs",
        clearable: "",
        style: {"max-width":"200px"}
      }, {
        prepend: _withCtx(() => [
          _createVNode(_component_q_icon, { name: "search" })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_btn, {
        flat: "",
        dense: "",
        icon: _ctx.sortAscending ? 'arrow_upward' : 'arrow_downward',
        color: "blue-brand",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sortAscending = !_ctx.sortAscending))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tooltip, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.sortAscending ? 'Ascending' : 'Descending'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["icon"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, "All in Group (" + _toDisplayString(_ctx.availableAgms.length) + ")", 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_q_btn, {
              flat: "",
              dense: "",
              "no-caps": "",
              color: _ctx.isTrimmed ? 'orange-8' : 'blue-grey-6',
              label: _ctx.isTrimmed ? 'Reset' : 'Trim',
              disable: !_ctx.isTrimmed && !_ctx.hasTrimableAgms,
              onClick: _ctx.onTrim
            }, {
              default: _withCtx(() => [
                (!_ctx.isTrimmed)
                  ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("This will remove the AGMs that are currently involved in active pig runs", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["color", "label", "disable", "onClick"]),
            _createVNode(_component_q_btn, {
              flat: "",
              dense: "",
              "no-caps": "",
              color: "blue-brand",
              label: _ctx.allAvailableSelected ? 'Deselect All' : 'Select All',
              onClick: _ctx.onToggleSelectAllAvailable
            }, null, 8, ["label", "onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_q_input, {
            modelValue: _ctx.availableRangeFrom,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.availableRangeFrom) = $event)),
            dense: "",
            outlined: "",
            type: "number",
            label: "From",
            style: {"max-width":"80px"},
            color: "blue-brand"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_q_input, {
            modelValue: _ctx.availableRangeTo,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.availableRangeTo) = $event)),
            dense: "",
            outlined: "",
            type: "number",
            label: "To",
            style: {"max-width":"80px"},
            color: "blue-brand"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_q_btn, {
            flat: "",
            dense: "",
            "no-caps": "",
            color: "blue-brand",
            label: 
              _ctx.availableRangeCount > 0
                ? `Select Range (${_ctx.availableRangeCount})`
                : 'Select Range'
            ,
            disable: !_ctx.availableRangeFrom || !_ctx.availableRangeTo,
            onClick: _ctx.onSelectAvailableRange
          }, null, 8, ["label", "disable", "onClick"])
        ]),
        _createVNode(_component_q_list, {
          ref: "availableList",
          bordered: "",
          separator: "",
          class: "rounded-borders",
          style: {"min-width":"250px","height":"300px","overflow-y":"auto"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAvailableAgms, (agm) => {
              return (_openBlock(), _createBlock(_component_q_item, {
                key: 'avail-' + agm.value,
                clickable: "",
                active: _ctx.availableSelection.some((s) => s.value === agm.value),
                "active-class": "bg-blue-1 text-blue-brand",
                onClick: ($event: any) => (_ctx.onToggleAvailable(agm))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agm.label), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["active", "onClick"]))
            }), 128))
          ]),
          _: 1
        }, 512)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_q_btn, {
          class: "btn-brand",
          label: ">>",
          dense: "",
          style: {"min-width":"60px"},
          onClick: _ctx.onMoveRight
        }, null, 8, ["onClick"]),
        _createVNode(_component_q_btn, {
          class: "btn-brand",
          label: "<<",
          dense: "",
          style: {"min-width":"60px"},
          onClick: _ctx.onMoveLeft
        }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, "Selected (" + _toDisplayString(_ctx.selectedAgms.length) + ")", 1),
          _createVNode(_component_q_btn, {
            flat: "",
            dense: "",
            "no-caps": "",
            color: "blue-brand",
            label: _ctx.allSelectedSelected ? 'Deselect All' : 'Select All',
            onClick: _ctx.onToggleSelectAllSelected
          }, null, 8, ["label", "onClick"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_q_input, {
            modelValue: _ctx.selectedRangeFrom,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedRangeFrom) = $event)),
            dense: "",
            outlined: "",
            type: "number",
            label: "From",
            style: {"max-width":"80px"},
            color: "blue-brand"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_q_input, {
            modelValue: _ctx.selectedRangeTo,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedRangeTo) = $event)),
            dense: "",
            outlined: "",
            type: "number",
            label: "To",
            style: {"max-width":"80px"},
            color: "blue-brand"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_q_btn, {
            flat: "",
            dense: "",
            "no-caps": "",
            color: "blue-brand",
            label: 
              _ctx.selectedRangeCount > 0
                ? `Select Range (${_ctx.selectedRangeCount})`
                : 'Select Range'
            ,
            disable: !_ctx.selectedRangeFrom || !_ctx.selectedRangeTo,
            onClick: _ctx.onSelectSelectedRange
          }, null, 8, ["label", "disable", "onClick"])
        ]),
        _createVNode(_component_q_list, {
          ref: "selectedList",
          bordered: "",
          separator: "",
          class: "rounded-borders",
          style: {"min-width":"250px","height":"300px","overflow-y":"auto"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedSelectedAgms, (agm) => {
              return (_openBlock(), _createBlock(_component_q_item, {
                key: 'sel-' + agm.value,
                clickable: "",
                active: _ctx.selectedSelection.some((s) => s.value === agm.value),
                "active-class": "bg-blue-1 text-blue-brand",
                onClick: ($event: any) => (_ctx.onToggleSelected(agm))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(agm.label), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["active", "onClick"]))
            }), 128))
          ]),
          _: 1
        }, 512)
      ])
    ])
  ]))
}